export const HalcyonTaxTranscriptFormTestIds = {
  TRANSCRIPT_METHOD_SELECT: 'halcyon-tax-transcript-form.transcript-method-select',
  FORMS_SELECT: 'halcyon-tax-transcript-form.forms-select',
  YEAR_MODE_SELECT: 'halcyon-tax-transcript-form.year-mode-select',
  SPECIFIC_YEARS_SELECT: 'halcyon-tax-transcript-form.specific-years-select',
  RESUBMIT_MODE_SELECT: 'halcyon-tax-transcript-form.resubmit-mode-select',
  AUTHORIZATION_SOURCE_SELECT: 'halcyon-tax-transcript-form.authorization-source-select',
  BORROWERS_SELECT: 'halcyon-tax-transcript-form.borrowers-select',
};
